import { TableColumn } from "../../../../components/ModularDataTable"
import { StatusTablePluginspace } from "../components/statusTablePluginspace"

export function generateColumnsPluginSpace(): TableColumn[] {
    
     const columns: TableColumn[] = [
        { key: 'Tipo', value: 'type', type: 'text' },
        { key: 'Id', value: 'id', type: 'text' },
        { key: 'Nome', value: 'name', type: 'text' },
        { key: 'Subdomínio', value: 'subdomain', type: 'text' },
        {
            key: 'Status',
            value: 'status',
            type: 'custom',
            render: (value: any, row: any) => (<StatusTablePluginspace row={row} />)
        },
        { key: 'Criado em', value: 'created', type: 'datetime' },
        { key: 'CNPJ', value: 'cnpj', type: 'text' },
    ]

    

    return columns
}